import { useEffect, useState } from "react";
import Menu from "../../CONTAINERS/menu/menu";

import { OverlayTrigger, Modal, Spinner, Alert, Container, Row, Col, Card, Pagination, Stack, InputGroup, ProgressBar } from "react-bootstrap";

import { ConfigProvider, Button, Form, Divider, Space, Tooltip, Image, Select, DatePicker, Checkbox, Input, Switch } from "antd";

import { ConsoleSqlOutlined, UserOutlined } from '@ant-design/icons';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faImages,
  faDiagramPredecessor,
  faHandSparkles,
} from "@fortawesome/free-solid-svg-icons";

import type { InputNumberProps } from "antd";
import { InputNumber } from "antd";

import { useLocation } from "react-router-dom";
import { ESTILOS_COLORES } from "../../API/CONSTANTS/constants";

import {
  creaTicketRegistroTopdesk,
  traerUsuarioTopdesk,
  traeUsuarios,
} from "./Services/OperadoresBC";

import logoSTK from "../../ASSETS/images/logo-starken.png";
import AlertaCentral from "../../SHARED/CentralAlertas";
import Topdesk from "../../API/MICROSERVICES/topdesk/topdesk";
import { validarOf, validarTicketGestion } from "./Services/ValidadorBC";
import tracking from "../../API/MICROSERVICES/tracking/tracking";


export default function IngresoBC(props: any) {

  const [form] = Form.useForm();

  const { TextArea } = Input;

  const { history } = props; // para los cambios de pagina

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  let UserID = params.get("userid");

  const [usuarioLogeado, setUsuarioLogeado] = useState("Usuario Logeado");
  const [agenciaLogeada, setAgenciaLogeada] = useState("Agencia Logeada");
  const [tasLogginName, setTasLogginName] = useState("");

  const [estGestion, setEstGestion] = useState(false);
  const [estGaleria, setEstGaleria] = useState(false);

  const [botonLimpiar, setBotonLimpiar] = useState(false);

  const [showU, setShowU] = useState(false);
  const [selectBoton, setSelectBoton] = useState(false);
  const [orden_flete, setOrden_flete] = useState("");

  const [OfOriginal, setOfOriginal] = useState("");
  const [OfBultoCiego, setOfBultoCiego] = useState("");
  const [TicketGestion, setTicketGestion] = useState("");
  const [Observacion, setObservacion] = useState("");

  const onChangeInput: InputNumberProps["onChange"] = (value) => {
    let largo: number = value != null ? String(value).length : 0;

    let OrdenFlete: string = value != null ? String(value) : "";

    if (largo > 5) {
      setSelectBoton(true);
      setOrden_flete(OrdenFlete);
    } else {
      setSelectBoton(false);
    }
  };


  const onChangeInputOfOriginal: InputNumberProps["onChange"] = (value) => {
    let largo: number = value != null ? String(value).length : 0;

    let OrdenFlete: string = value != null ? String(value) : "";

    console.log(OrdenFlete);

    setOfOriginal(OrdenFlete);

  };

  const onChangeInputOfBultoCiego: InputNumberProps["onChange"] = (value) => {
    let largo: number = value != null ? String(value).length : 0;

    let OrdenFlete: string = value != null ? String(value) : "";

    console.log(OrdenFlete);

    setOfBultoCiego(OrdenFlete);

  };

  const onChangeInputTicketGestion: InputNumberProps["onChange"] = (value) => {
    let largo: number = value != null ? String(value).length : 0;

    let ticket: string = value != null ? String(value) : "";



    let newValue = ticket;
    if (newValue.length > 4 && !newValue.includes('-')) {
      // Agregar un - en la posición 4
      newValue = newValue.substring(0, 4) + '-' + newValue.substring(4);
    }
    setTicketGestion(newValue);


    console.log(newValue);


  };


  const onChangeInputObservacion = (value: any) => {
    let largo: number = value != null ? String(value).length : 0;

    let observacion: string = value != null ? String(value) : "";


    console.log(observacion);

    setObservacion(observacion);

  };

  useEffect(() => {

    if (Observacion != "" || TicketGestion != "" || OfOriginal != "" || OfBultoCiego != "") {
      setBotonLimpiar(true);
    } else {
      setBotonLimpiar(false);
    }


  }, [Observacion, TicketGestion, OfOriginal, OfBultoCiego]);

  function LimpiarFormulario() {
    setOfOriginal("");
    setOfBultoCiego("");
    setTicketGestion("");
    setObservacion("");



  }

  const onReset = () => {
    form.resetFields();
  };




  const Color_Main_BackGround = ESTILOS_COLORES.MAIN_BACKGROUND;
  const Color_BackGround_Limpieza = ESTILOS_COLORES.BACKGROUND_LIMPIEZA;
  const Color_Limpieza = ESTILOS_COLORES.LIMPIEZA;
  const Color_Blanco = ESTILOS_COLORES.BLANCO;
  const Color_Verde = ESTILOS_COLORES.VERDE;
  const Color_Rojo = ESTILOS_COLORES.ROJO;


  const [cambio, setCambio] = useState(false);



  const onChange = (checked: boolean) => {
    setCambio(checked);
  };

  useEffect(() => { }, [selectBoton]);

  async function continuar() {
    setShowU(true);


    if (UserID != null) {
      let usuario = await traerUsuarioTopdesk(tasLogginName);
      let Id_Usuario = usuario.data[0].id;


      let ticket: any = await crearTicketRegistro(
        Id_Usuario,
        UserID,
        cambio,
        orden_flete
      );

      if (ticket.status == 201) {
        setTimeout(() => {
          setShowU(false);
          paginaSiguiente();
        }, 10);
      } else {
        setShowU(false);
        AlertaCentral("ERRORTIECKETREGISTRO", "", "", "", "");
      }
    } else {
      AlertaCentral("ERRORTIECKETREGISTRO", "", "", "", "");

      paginaSiguiente();
    }
  }

  async function crearTicketRegistro(
    id: any,
    nombreLoggin: any,
    tieneof: boolean,
    orden_flete?: any
  ) {
    let TieneOrden = "";

    if (cambio) {
      TieneOrden = "Con OF";
    } else {
      TieneOrden = "Sin Of";
    }

    let body = {
      callerLookup: {
        id: id,
      },
      status: "firstLine",
      briefDescription: "Ingreso Galería Bulto Ciego",
      request: `<b> DATOS </b> <br /> <br />nombre: ${nombreLoggin} <br /> Tiene OF: ${tieneof} <br /> N°OF: ${orden_flete}`,
      category: {
        name: "Ingreso Galería Bulto Ciego",
      },
      subcategory: {
        name: TieneOrden, //CON FO para cuando tenga y Sin OF cuando no.
      },
      optionalFields1: {
        text2: orden_flete,
      },
      processingStatus: {
        name: "Cerrado",
      },
    };

    let respuesta = await creaTicketRegistroTopdesk(body);

    return respuesta;
  }


  function paginaSiguiente() {
    history.push("/Main");
  }


  const handleGestion = async () => {

    if (estGestion) {
      setEstGestion(false);
    } else {
      setEstGestion(true);
    }

    setEstGaleria(false);

  };


  const handleGaleria = async () => {

    if (estGaleria) {
      setEstGaleria(false);
    } else {
      setEstGaleria(true);
    }
    setEstGestion(false);


  }


  async function CargaDatosLogeados() {

    console.log("CargaDatos Logeados");

    if (usuarioLogeado != "Usuario Logeado") {

      console.log("Datos de usuario ya cargados.");

    } else {

      try {

        if (UserID != null && UserID !== undefined && UserID !== "") {

          let us = await Topdesk.infoUsuarios(UserID);

          let tasUserLoggin = us.data.tasLoginName;

          setTasLogginName(tasUserLoggin);

          let usuario = us.data.birthName;
          let agencia = us.data.branch.name;

          let forzar = async () => {

            setTimeout(() => {
              setAgenciaLogeada(agencia);
              setUsuarioLogeado(usuario);
            }, 100);
          };

          await forzar();

          setAgenciaLogeada(agencia);
          setUsuarioLogeado(usuario);


        } else {
          console.log("Error al recibir el parametro del usuario en url.");
        }

      } catch (e) {
        console.log("Error al cargar datos de usuario logeado.");
      }
    }
  }

  useEffect(() => {
    CargaDatosLogeados();
  }, []);

  async function Gestionar() {
    console.log("Gestionar");

    setShowU(true);

    let validaciones = await Validaciones();

    if (validaciones) {
      console.log("Puedo generar el ticket");


      console.log("Aqui tengo que ir por la informacion del ticket de bulto ciego con la ordende flete")
      console.log("Puedo traer los datos de la of desde dls");


      console.log("Modificar campos en el ticket de la galeria");




    } else {
      console.log("No puedo generar el ticket");
    }

    setShowU(false);
  }

  async function Validaciones() {
    console.log("Validaciones");

    let resultado = true;


    try {


      let ofOriginalCorrecta = await tracking.detalle({ of: Number(OfOriginal) }).then((resp: any) => {
        console.log("resp ", resp);
        let data = resp;


        if (data.status === -2) {

          AlertaCentral("VPNNOCONECTADA", "", "", "", "");

        } else if (data.status === -1) {

          AlertaCentral("SININTERNET", "", "", "", "");

        }

        return validarOf(data);
      })


      let ofBultoCiegoCorrecta = await tracking.detalle({ of: Number(OfBultoCiego) }).then((resp: any) => {
        console.log("resp ", resp);
        let data = resp;

        if (data.status === -2) {

          AlertaCentral("VPNNOCONECTADA", "", "", "", "");

        } else if (data.status === -1) {

          AlertaCentral("SININTERNET", "", "", "", "");

        }



        return validarOf(data);
      });


      let ticketGestionCorrecto = await validarTicketGestion(TicketGestion);

      console.log("ofOriginalCorrecta", ofOriginalCorrecta);
      console.log("ofBultoCiegoCorrecta", ofBultoCiegoCorrecta);
      console.log("ticketGestionCorrecto", ticketGestionCorrecto);


      if (ofOriginalCorrecta && ofBultoCiegoCorrecta && ticketGestionCorrecto) {
        resultado = true;


      } else if (ofOriginalCorrecta && ofBultoCiegoCorrecta && !ticketGestionCorrecto) {

        AlertaCentral("TICKETERRONEO", "", "", "", "");

        resultado = false;
      } else if (!ofOriginalCorrecta && ofBultoCiegoCorrecta && ticketGestionCorrecto) {

        AlertaCentral("OFORIGINALERRONEA", "", "", "", "");

        resultado = false;
      } else if (ofOriginalCorrecta && !ofBultoCiegoCorrecta && ticketGestionCorrecto) {



        AlertaCentral("OFBULTOCIEGOERRONEA", "", "", "", "");

        resultado = false;
      } else if (!ofOriginalCorrecta && !ofBultoCiegoCorrecta && ticketGestionCorrecto) {



        AlertaCentral("OFORIGINALYOFBULTOCIEGOERRONEOS", "", "", "", "");


        resultado = false;
      } else if (ofOriginalCorrecta && !ofBultoCiegoCorrecta && !ticketGestionCorrecto) {




        AlertaCentral("OFBULTOCIEGOYTIKETERRONEOS", "", "", "", "");

        resultado = false;
      } else if (!ofOriginalCorrecta && ofBultoCiegoCorrecta && !ticketGestionCorrecto) {


        AlertaCentral("OFORIGINALYTIKETERRONEOS", "", "", "", "");

        resultado = false;
      } else if (!ofOriginalCorrecta && !ofBultoCiegoCorrecta && !ticketGestionCorrecto) {

        AlertaCentral("OFORIGINALYOFBULTOCIEGOYTIKETERRONEOS", "", "", "", "");

        resultado = false;
      }


    } catch (e) {

      AlertaCentral("Hola", "", "", "", "");

    }



    return resultado;
  }

  return (
    <>
      {/* MENU */}
      <Menu titulo="Ingreso Galería Bulto Ciego" logo="" />

      <Container
        fluid="xl"
        className="mt-2 mb-2 rounded pt-3 pb-3 shadow"
        style={{ background: Color_Main_BackGround }}
      >
        <Container
          className="rounded shadow border"
          style={{ background: Color_Blanco }}>
          <Container fluid="xl" className="text-center mt-1 mb-1">
            <Row>
              <Col
                className="d-flex justify-content-end mt-2 mb-2"
                style={{ color: Color_Verde }}
              >
                <Button
                  type="primary"
                  style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                  onClick={() => {
                    handleGestion();
                    CargaDatosLogeados();
                  }}
                >
                  {" "}
                  <FontAwesomeIcon icon={faDiagramPredecessor} />
                  &nbsp; Gestión Externa
                </Button>
              </Col>

              <Col
                className="d-flex justify-content-start mt-2 mb-2"
                style={{ color: Color_Verde }}
              >
                <Button
                  type="primary"
                  style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                  onClick={() => {
                    handleGaleria();
                    CargaDatosLogeados();
                  }}
                >
                  {" "}
                  <FontAwesomeIcon icon={faImages} /> &nbsp; Ingreso Galería
                </Button>
              </Col>
            </Row>
          </Container>
        </Container>
      </Container>

      <Container
        hidden={!estGestion}
        fluid="xl"
        className="mt-2 mb-2 rounded pt-3 pb-3 shadow"
        style={{ background: Color_Main_BackGround }}
      >
        <Container
          className="rounded shadow border"
          style={{ background: Color_Blanco }}
        >

          <Container fluid="xl" className="text-center mt-3 mb-3">
            <h4 style={{ color: Color_Verde }}>
              Registrar gestión fuera de galería{" "}
            </h4>
          </Container>

          <Container fluid="xl" className="mt-3 mb-3">
            <Form
              name="basic"
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              autoComplete="off"
              onFinish={Gestionar}


            >

              <Row>
                <Form.Item
                  label="Orden de Flete Original"
                  name="ofOriginal"
                  rules={[
                    { required: true, message: "Por Favor ingrese Orden de Flete Original" },
                  ]}
                >
                  <Input
                    placeholder="Ingrese Orden de Flete Original"
                    maxLength={9}
                    minLength={6}
                    pattern="[0-9]*"
                    showCount onChange={(e: any) => { onChangeInputOfOriginal(e.target.value) }}
                  />
                </Form.Item>
              </Row>

              <Row>

                <Form.Item
                  label="Orden de Flete Bulto Ciego "
                  name="ofBultoCiego"
                  rules={[
                    { required: true, message: "Por Favor ingrese Orden de Flete Bulto Ciego" },
                  ]}
                >
                  <Input
                    placeholder="Ingrese Orden de Flete Bulto Ciego"
                    maxLength={9}
                    minLength={6}
                    pattern="[0-9]*"
                    showCount
                    onChange={(e: any) => { onChangeInputOfBultoCiego(e.target.value) }}
                  />
                </Form.Item>

              </Row>


              <Row>
                <Form.Item
                  label="Ticket Gestión Externa"
                  name="ticket1"
                  extra="Ingrese SÓLO los números del Ticket, sin guion."
                  rules={[
                    { required: true, message: "Por Favor ingrese Ticket Gestión Externa" },
                  ]}>
                  <Space direction="vertical" size="middle">
                    <Space.Compact>
                      <Input style={{ width: '10%' }}
                        disabled
                        defaultValue="S"
                      />

                      <Input
                        style={{ width: '80%' }}
                        placeholder="Ingrese Ticket Gestión Externa"

                        pattern="[0-9]*"
                        maxLength={10}
                        minLength={6}
                        showCount
                        onChange={(e: any | string) => { onChangeInputTicketGestion(e.target.value) }}
                      />
                    </Space.Compact>
                  </Space>
                </Form.Item>
              </Row>

              <Row>
                <Form.Item
                  label="Observaciones"
                  name="observacion"
                  rules={[
                    { required: true, message: "Por Favor ingrese Observaciones" },
                  ]}
                >
                  <TextArea
                    rows={4}
                    placeholder="Largo Máximo 120 Carácteres"
                    maxLength={120}
                    showCount
                    onChange={(e: any) => { onChangeInputObservacion(e.target.value) }}
                  />
                </Form.Item>
              </Row>

              <Row>
                <Form.Item
                  label="Usuario"
                  name="Usuario"
                  rules={[
                    { required: false },
                  ]}
                >
                  <Input disabled={true} placeholder={usuarioLogeado} value={usuarioLogeado} />
                </Form.Item>
              </Row>

              <Row>
                <Form.Item
                  label="Agencia"
                  name="Agencia"
                  rules={[
                    { required: false },
                  ]}
                >
                  <Input disabled={true} placeholder={agenciaLogeada} />
                </Form.Item>
              </Row>

              <Row>
                <Col></Col>
                <Col>
                  <Form.Item label={null} className="text-end">

                    {

                      botonLimpiar ? (<Button
                        type="primary"
                        style={{ color: Color_Verde, backgroundColor: "#a3dab3ff" }}
                        onClick={() => { LimpiarFormulario(); onReset(); }}
                      >
                        <FontAwesomeIcon icon={faHandSparkles} />{" "}
                        &nbsp;&nbsp;
                        Limpiar
                      </Button>) :
                        (<Button
                          type="primary"
                          disabled
                        >
                          <FontAwesomeIcon icon={faHandSparkles} />{" "}
                          &nbsp;&nbsp;
                          Limpiar
                        </Button>)


                    }
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item label={null} className="text-end">
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ color: Color_Blanco, backgroundColor: Color_Verde }}
                    >
                      Gestionar
                    </Button>
                  </Form.Item>
                </Col>
                <Col></Col>
              </Row>

            </Form>

          </Container>
        </Container>
      </Container>

      <Container
        hidden={!estGaleria}
        fluid="xl"
        className="mt-2 mb-2 rounded pt-3 pb-3 shadow"
        style={{ background: Color_Main_BackGround }}
      >
        <div
          className="rounded shadow border"
          style={{ background: Color_Blanco }}
        >
          <Container fluid="xl" className="text-center mt-3 mb-3">
            <Row className="row"></Row>

            <Row className="mt-4">
              <Col style={{ color: Color_Verde }}>
                <b> ¿ {usuarioLogeado} Tiene Orden de Flete* ? </b>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-center mt-2">
                <Col
                  className="col-2 d-flex justify-content-center"
                  style={{ color: Color_Verde }}
                >
                  <b> NO </b>
                </Col>
                <Col className="col-2">
                  <Switch
                    onChange={onChange}
                    style={{ background: Color_Verde }}
                  />
                </Col>
                <Col
                  className="col-2 d-flex justify-content-center"
                  style={{ color: Color_Verde }}
                >
                  <b> SI </b>
                </Col>
              </Col>
            </Row>
            <Row hidden={!cambio} className="mt-4">
              <Col className="d-flex justify-content-end">
                <label style={{ color: Color_Verde }}>
                  Ingresar Orden de Flete :
                </label>
              </Col>
              <Col className="d-flex justify-content-start">
                <InputNumber
                  onChange={onChangeInput}
                  style={{ width: "130px" }}
                />
              </Col>
            </Row>

            <Row className="mt-4">
              <Col>
                {cambio ? (
                  <>
                    {selectBoton ? (
                      // este es cuando tiene una of de mas de 6 digitos
                      <>
                        <Button
                          type="primary"
                          style={{
                            color: Color_Blanco,
                            backgroundColor: Color_Verde,
                          }}
                          onClick={() => {
                            continuar();
                          }}
                        >
                          Continuar
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button disabled>Continuar</Button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {/* este es cuando es false y no tiene orden de flete */}
                    <Button
                      type="primary"
                      style={{
                        color: Color_Blanco,
                        backgroundColor: Color_Verde,
                      }}
                      onClick={() => {
                        continuar();
                      }}
                    >
                      Continuar
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* MODAL LOADING */}

      <Modal
        show={showU}
        size="sm"
        backdrop="static"
        keyboard={false}
        name="loading"
      >
        <Modal.Header className="text-center justify-content-center">
          <img alt="Starken" src={logoSTK} style={{ height: "45px" }} />
        </Modal.Header>
        <Modal.Body>
          <Container className="text-center">
            <Spinner
              animation="border"
              role="status"
              variant="success"
              size="sm"
            />
            <Spinner animation="border" role="status" variant="success" />
          </Container>
          <Container className="text-center">
            <h6 style={{ color: Color_Verde }}>Cargando...</h6>
          </Container>
          <hr />
          <Container className="text-center"></Container>
        </Modal.Body>
      </Modal>
    </>
  );
}
